module.exports = __webpack_public_path__ + "static/img/after-sale-swan-1.b02ef643.png";